import React, {Component} from 'react';
import {FormattedMessage} from "react-intl";
import {ModalHeader, ModalBody, ModalFooter, Modal, Button} from "reactstrap";
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import 'ladda/dist/ladda-themeless.min.css';
import ColumnForm from "./ColumnForm";
import {connect} from 'react-redux';
import {addRespondentBaseColumn} from "reducers/user/actions";
import PropTypes from "prop-types";

class ColumnCreateModal extends Component {

  constructor(props) {
    super(props);

    this.state = {
      saving: false,
      errors: {}
    };
    this.columnCreate = this.columnCreate.bind(this);
    this.columnForm = React.createRef();
  }

  columnCreate(e, data) {
    e.preventDefault();
    this.setState({saving: true, errors: {}});

    this.props.addRespondentBaseColumn({data: {
        name: data.name
      }})
      .then(() => {
        this.setState({
          saving: false
        });
        this.props.toggle();
      })
      .catch(e => {
        this.setState({
          saving: false,
          errors: e.response.data.form ? e.response.data.form.errors : {}
        });
      });
  }

  render() {
    const { saving, errors } = this.state;

    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} size="lg">
        <ModalHeader toggle={this.props.toggle} tag="h2"><FormattedMessage id="columnCreateButton.modalHeader" /></ModalHeader>
        <hr className="my-0" />
        <ModalBody>
          <ColumnForm onSubmit={this.columnCreate} column={this.props.column} ref={this.columnForm} errors={errors}/>
        </ModalBody>
        <ModalFooter>
          <div className="direction-group d-flex justify-content-end">
            <div className="direction-right">
              <FormattedMessage id="_.button.save">{
                (message) => <LaddaButton
                  className="btn btn-primary btn-ladda mb-0 ml-3"
                  loading={saving}
                  data-style={ZOOM_OUT}
                  onClick={e => this.columnCreate(e, this.columnForm.current.state)}
                >
                  {message}
                </LaddaButton>
              }</FormattedMessage>
              <FormattedMessage id="_.button.cancel">{
                (message) =>
                  <Button color="secondary" className="mb-0 ml-3" onClick={this.props.toggle}>{message}</Button>
              }</FormattedMessage>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    )
  }
}

ColumnCreateModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default connect(null, {addRespondentBaseColumn}, null, {forwardRef: true})(ColumnCreateModal);